import LoadingCircle from "../../utils/LoadingCircle";
import { useEffect, useState } from "react";
import { getFunctions } from "firebase/functions";
import { httpsCallable } from "../../../shared/legacyData/legacyCallable";
import { useSelector } from "react-redux";
import ManageRecord from "../systemUtils/ManageRecord";
import Navbar from "../systemUtils/Navbar";
import "./ClaimsSystem.css";

const SingleClaimView = ({
  stateButtonsConfig,
  claimID,
  extractDataPoints = () => {},
}) => {
  console.log("Viewing claim with ID:", claimID);
  const [loading, setLoading] = useState(false);
  const [claim, setClaim] = useState(null);
  const [activeTab, setActiveTab] = useState("view users");
  const [buttonsConfig, setButtonsConfig] = useState(stateButtonsConfig);
  const [invoiceUrl, setInvoiceUrl] = useState(null);
  const [receiptUrl, setReceiptUrl] = useState(null);
  const [isPaid, setIsPaid] = useState(false);

  const redirectToHome = () =>
    window.location.replace("/hero-dashboard/claims");

  const [actionResult, setActionResult] = useState({
    visible: false, // Whether to show the ResultScreen
    success: null, // null => no success/error state yet
    message: "", // Message for the result screen
  });

  const functions = getFunctions();
  const fetchFileUrl = httpsCallable(functions, "fetchFileUrl");
  const getSystemDocuments = httpsCallable(functions, "getSystemDocuments");

  const {
    email: userEmail,
    userRole,
    company,
    collectionBrand,
  } = useSelector((state) => state.heroUser);

  const getInvoiceUrl = async (id) => {
    const bucket = "andus-education.appspot.com";
    const storagePath = `TPC_Group/shared/claims/${id}/invoice`;
    const url = await fetchFileUrl({
      bucketName: bucket,
      storagePath: storagePath,
    });
    const unpackedUrl = url.data.url;
    return unpackedUrl;
  };

  const getReceiptUrl = async (id) => {
    const bucket = "andus-education.appspot.com";
    const storagePath = `TPC_Group/shared/receipts/${id}/receipt`;
    const url = await fetchFileUrl({
      bucketName: bucket,
      storagePath: storagePath,
    });
    const unpackedUrl = url.data.url;
    return unpackedUrl;
  };

  const fetchClaim = async () => {
    if (claim) return; // Avoid refetching if already loaded
    const systemName = "claims"; // Define the system name for claims
    try {
      setLoading(true);
      console.log("Fetching claims using getSystemDocuments...");

      const result = await getSystemDocuments({
        company,
        collectionBrand,
        systemName,
        auth: true, // Add auth parameter as required by the cloud function
      });

      console.log("getSystemDocuments result:", result);

      if (result.data.success) {
        const claimsData = result.data.data;
        console.log("Claims data fetched:", claimsData);
        const claimToAdjudicate = claimsData.find(
          (claim) => claim.id === claimID
        );
        console.log("Claim to adjudicate:", claimToAdjudicate);
        setClaim(claimToAdjudicate);
        extractDataPoints(claimToAdjudicate);
      } else {
        console.error("Failed to fetch claims:", result.data);
      }
    } catch (error) {
      console.error("Error fetching claims: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClaim();
  }, []);

  const extractClaimData = async () => {
    // extractDataPoints(claim);
    if (claim?.status === "PAID") {
      setButtonsConfig([
        {
          state: "active",
          buttons: [],
        },
      ]);
    }
    const invoiceUrl = await getInvoiceUrl(claimID);
    const receiptUrl = await getReceiptUrl(claimID);
    setInvoiceUrl(invoiceUrl);
    setReceiptUrl(receiptUrl);
  };

  useEffect(() => {
    extractClaimData();
    if (claim?.status === "PAID") setIsPaid(true);
  }, [claim]);

  const links = ["View Claims", "Add Claim"];
  const handleTabClick = (tab) => {
    if (tab === "View Claims") {
      window.location.replace("/hero-dashboard/claims");
    } else if (tab === "Add Claim") {
      window.location.replace("/hero-dashboard/claims/add");
      setActiveTab(tab.toLowerCase());
    }
  };
  return (
    <div>
      <Navbar
        links={links}
        onLinkClick={handleTabClick}
        activeTab={activeTab}
      />

      {invoiceUrl && (
        <a
          href={invoiceUrl}
          class="button"
          download
          target="_blank"
          rel="noreferrer"
        >
          Download Original Invoice
        </a>
      )}

      {isPaid && receiptUrl && (
        <a
          href={receiptUrl}
          class="button"
          download
          target="_blank"
          rel="noreferrer"
        >
          Download Proof of Payment
        </a>
      )}

      {loading && <LoadingCircle />}

      {claim && (
        <div>
          <ManageRecord
            record={claim}
            currentState={claim.status || "PENDING"}
            role={userRole}
            buttonConfig={buttonsConfig}
            currentUser={userEmail}
            system="claims"
            systemName="claims"
            loading={false}
            actionStatus={
              actionResult && actionResult.visible
                ? actionResult.success
                  ? "success"
                  : "error"
                : null
            }
            actionMessage={actionResult ? actionResult.message : ""}
            visible={actionResult.visible}
            onResetActionState={() => {}}
            collectionBrand={collectionBrand}
            company={company}
            setIsManageRecordVisible={redirectToHome}
          />
        </div>
      )}
    </div>
  );
};

export default SingleClaimView;
